import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../state/GlobalStateProvider';
import ChatStep from './Steps/ChatStep';
import Step0 from './Steps/Step0';
import Whitelist from './Whitelist/Whitelist';

const Main = () => {
  const [{ user }] = useGlobalState();
  const [onboarding, setOnboarding] = useState();
  const [step, setStep] = useState(0);
  console.log({ onboarding });

  const Steps = [<Step0 onNext={onNext} />, <ChatStep onNext={onNext} />, <Whitelist />];

  function onNext() {
    if (Steps.length - 1 <= step) return;
    console.log('incremented');
    setStep(step + 1);
  }

  function onBack() {
    if (step <= 0) return;
    setStep(step - 1);
  }

  useEffect(() => {
    let userOnbaording = localStorage.getItem(`onboarding_${user?.address}`);
    if (Boolean(userOnbaording)) {
      setStep(2);
    }
    setOnboarding(userOnbaording);
  }, [user]);
  if (onboarding === undefined) return <></>;
  return <>{Steps[step]}</>;
};

export default Main;
